module.exports = __webpack_public_path__ + "img/truck-sm-grey.5de3a0bf.svg";